var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { gql } from '@apollo/client/core';
import * as Order from './Order';
import { VENUE_FIELDS } from '../Venue/Api';
import { EVENT_FIELDS_MINIMAL } from '../Event/Api';
const TICKET_FIELDS = gql `
  fragment TicketFields on Ticket {
    id
    token
    firstName
    lastName
    name
    seat
    table
    ticketType
    checkedInBy {
      name
      email
    }
    price
    pdfUrl
    pdfPreviewUrl
  }
`;
const ORDER_FIELDS = gql `
  fragment OrderFields on Order {
    id
    ticketLayout
    code
    customer {
      email
      firstName
      lastName
    }
    event {
      ...EventFieldsMinimal
      announceDetail {
        id
        promoter
        support
      }
    }
    venue {
      ...VenueFields
    }
    tickets {
      ...TicketFields
    }
  }
  ${TICKET_FIELDS}
  ${VENUE_FIELDS}
  ${EVENT_FIELDS_MINIMAL}
`;
const ORDER_QUERY = gql `
  query Order($id: Int!) {
    app {
      order(id: $id) {
        ...OrderFields
      }
    }
  }
  ${ORDER_FIELDS}
`;
export const fetchOrder = (client, id) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield client.query({
        query: ORDER_QUERY,
        variables: {
            id,
        },
    });
    return Order.fromGQL(data.app.order);
});
//# sourceMappingURL=Api.js.map